import React from 'react';
import PropTypes from 'prop-types';
import Routes from './routes';
import { ConnectedRouter as Router } from 'react-router-redux';

const App = ({history, persistor}) => (
  <Router {...{history}}>
    <Routes {...{persistor}}/>
  </Router>
);   

App.propTypes = {
  persistor: PropTypes.object.isRequired, 
  history: PropTypes.object.isRequired,
};

export default App;

